// extracted by mini-css-extract-plugin
export default {"videoClip":"video-clip_videoClip__uJb6Q"};